var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"hero is-info is-bold is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('HelloWorld')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }